/* eslint-disable import/prefer-default-export */
import { t } from '../i18n';

export const whoContent = {
    title: t('WHO_WE_ARE'),
    main_paragraphs: [t('WHO_P1'), t('WHO_P2')],
    highlight: t('WHO_HEADER'),
    subtitle_1: t('WHO_SUB1'),
    secondary_paragraph_1: t('WHO_SUB1_BODY'),
    subtitle_2: t('WHO_SUB2'),
    secondary_paragraph_2: t('WHO_SUB2_BODY'),
    subtitle_3: t('WHO_SUB3'),
    secondary_paragraph_3: t('WHO_SUB3_BODY'),
};
